/**
 * Watch and Shop API (BrightLaptopUI)
 * Fetches active video cards for the "Watch and Shop" home page section.
 */
import axiosInstance from "./axiosConfig";

/**
 * Get all active Watch and Shop videos sorted by order
 * @returns {Promise<{ success: boolean, videos: Array }>}
 */
export const getWatchAndShopVideos = async () => {
  try {
    const response = await axiosInstance.get("/laptops/watch-and-shop");
    return {
      success: true,
      videos: response.data?.data?.videos || [],
      header: response.data?.data?.header || null,
    };
  } catch (error) {
    console.error("Watch and Shop API error:", error.message);
    return { success: false, videos: [] };
  }
};
